import React from 'react';
import { FadeIn } from './FadeIn';
export function AgitationSection() {
  return <section className="py-20 lg:py-24 bg-lightGray px-4 sm:px-6 lg:px-8" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <FadeIn data-id="element-19">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-8 text-center tracking-tight" data-id="element-20">
            Ese pequeño error puede hacerte ver menos interesante, menos agudo y
            menos preparado
          </h2>

          <div className="prose prose-lg text-gray-600 mx-auto text-center mb-12" data-id="element-21">
            <p data-id="element-22">
              Cuando un candidato no hace preguntas, el entrevistador no asume
              que todo quedó claro. A menudo, lo interpreta como falta de
              interés, falta de visión estratégica o simplemente como alguien
              que solo busca "un trabajo más" en lugar de un reto profesional.
            </p>
          </div>

          <div className="bg-navy rounded-2xl p-8 md:p-12 border-l-8 border-emerald shadow-xl" data-id="element-23">
            <blockquote className="text-2xl md:text-3xl font-bold text-white leading-tight text-center" data-id="element-24">
              "No hacer preguntas no te hace ver seguro. Te hace ver pasivo."
            </blockquote>
          </div>
        </FadeIn>
      </div>
    </section>;
}